import api from './api';

// Download een bewaard rapport via de API (blob), zodat de JWT-header meegaat.
// window.open zou de Authorization-header niet meesturen.
export async function downloadReport(id, filename) {
  const res = await api.get(`/api/reports/${id}/download`, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || `rapport-${id}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
